import { useContext } from 'react'
import VoiceContext from "../../app/contexts/VoiceContext";

const useVoice = () => useContext(VoiceContext)

export default useVoice
